<template>
  <div>
    <portal to="toolbar-title" v-if="projectDetails"> {{ branch(projectDetails.Branch_ID).BranchAddress }} {{ projectDetails.ProjectName }}
    </portal>
    <portal to="header-content" v-if="projectDetails">
      <v-row>
        <callout-button class="mb-2 mr-2" is-modal
                              v-if="userDetails.Allows.AddCallouts"
                             :project_id="projectDetails.Project_ID"
                             :branch_id="projectDetails.Branch_ID"
                             :partner_id="projectDetails.Partner_ID"
      >
      </callout-button>
        <big-round-button color="primary" class="mr-3 mb-3" icon="mdi-wrench" text="ΣΥΝΤΗΡ."
                          :to="'/lift/'+projectDetails.Project_ID+'/maintenances'"></big-round-button>

        <big-round-button v-if="userDetails.Allows.ShowCallouts" color="primary" class="mr-3 mb-2" icon="mdi-alert-outline" text="ΒΛΑΒΕΣ"
                          :to="'/lift/'+projectDetails.Project_ID+'/callouts'"></big-round-button>

        <big-round-button color="primary" v-if="userDetails.Allows.ShowCallouts && userDetails.Allows.ShowMaintenances" class=" mb-3 mr-3" icon="mdi-history" text="ΙΣΤΟΡΙΚΟ"
                          :to="'/lift/'+projectDetails.Project_ID+'/history'"></big-round-button>

        <big-round-button color="primary" class="mr-3 mb-2" icon="mdi-clock-outline" text="ΠΕΡΙΟΔΙΚΕΣ ΕΡΓΑΣΙΕΣ"
                          :to="'/lift/'+projectDetails.Project_ID+'/periodic'"></big-round-button>

        <big-round-button color="primary" class=" mb-3 mr-3" icon="mdi-domain"
                          v-if="!userDetails.AltTiSi.IsProjectFromQRCode"
                          text="ΚΤΗΡΙΟ"
                          :to="'/building/'+projectDetails.Branch_ID"></big-round-button>

        <!--<big-round-button color="primary" class="mr-2 mb-2" icon="mdi-file" text="ΑΡΧΕΙΑ"  ></big-round-button>-->
      </v-row>
    </portal>
    <v-row class="mt-0">
      <v-col lg="12" sm="12" md="12" cols="12" style="padding-top:0">
        <router-view></router-view>
      </v-col>
    </v-row>
  </div>

</template>

<script>
import ProjectCard from "@/views/Projects/views/ProjectCard";
import projectMixin from "@/views/Projects/mixins/projectMixin";
import BigRoundButton from "@/components/BigRoundButton";
import CalloutButton from "@/views/Events/components/CalloutButton";
import DomainImage from "@/components/DomainImage";

export default {
  name: "Project",
  components: {DomainImage, CalloutButton, BigRoundButton, ProjectCard},
  created() {
    this.getProject(true)
  },
  mixins: [projectMixin],
  watch: {
  }
}
</script>

<style scoped>

</style>
